import SymbolShortcutsEditing from "./SymbolShortcutsEditing";
import SymbolShortcutsUI from "./SymbolShortcutsUI";

import "./symbolShortcuts.css";

import { Plugin } from "@ckeditor/ckeditor5-core";

/**
 * Adds one toolbar button per configured symbol (CDE-16014), each of which
 * inserts that symbol at the current selection.
 *
 * A single plugin covers all four smart quotes - and any symbol added later -
 * because the buttons are generated from the `symbolShortcuts.items`
 * configuration and share one `insertSymbol` command. Override the default set
 * per editor instance with:
 *
 * ```js
 * ClassicEditor.create( element, {
 *   symbolShortcuts: {
 *     items: [ { name: "emDash", character: "—", label: "Em dash" } ]
 *   },
 *   toolbar: { items: [ "emDash" ] }
 * } );
 * ```
 */
export default class SymbolShortcuts extends Plugin {
  static get pluginName() {
    return "SymbolShortcuts";
  }

  static get requires() {
    return [SymbolShortcutsEditing, SymbolShortcutsUI];
  }
}
